import { Range } from "@website/ui/range";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { RangeTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
type RangeFilterProperties = RangeTypes;
export const RangeFilter = (properties: RangeFilterProperties) => {
  const {
    title,
    description,
    min = 0,
    max = 0,
    step,
    min_key,
    max_key,
    showTitle = true,
    onValueChange,
    updateQueryOnChange = true
  } = properties;
  const router = useRouter();
  const updateQueryTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const {
    [min_key]: minQuery,
    [max_key]: maxQuery
  } = router.query as Record<string, string>;
  const minValue = Number(minQuery || min);
  const maxValue = Number(maxQuery || max);
  const [minValueState, setMinValueState] = useState(minValue);
  const [maxValueState, setMaxValueState] = useState(maxValue);
  useEffect(() => {
    setMinValueState(minValue);
    setMaxValueState(maxValue);
  }, [minValue, maxValue]);
  useEffect(() => () => {
    clearTimeout(updateQueryTimer.current);
  }, []);
  function _onChange(values: Array<number> | number, eventType: "maxOnChange" | "minOnChange") {
    if (Array.isArray(values)) {
      const [minV, maxV] = values;
      setMinValueState(minV);
      setMaxValueState(maxV);
      onValueChange?.([minV, maxV], eventType);
      if (!updateQueryOnChange) return;
      clearTimeout(updateQueryTimer.current);
      updateQueryTimer.current = setTimeout(() => {
        router.replace({
          query: deepOmit({
            ...router.query,
            [min_key]: minV === min ? undefined : minV,
            [max_key]: maxV === max ? undefined : maxV
          }, isFilled)
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }, 300);
    }
  }
  return <div className={styles["filter-range-container"]}>
      {showTitle && <div className={styles["filter-range-title"]}>{title}</div>}
      <label className={styles["filter-range-description"]} htmlFor="range_total_price">
        {description}
      </label>

      <div className={styles["filter-range-price"]}>
        <span>
          {`${numberConvert(numberSeparator(String(minValueState)), {
          locale: router.locale
        })} تومان`}
        </span>
        <span>
          {`${numberConvert(numberSeparator(String(maxValueState)), {
          locale: router.locale
        })} تومان`}
        </span>
      </div>

      <Range color="secondary" id="range_total_price" max={max} min={min} onChange={_onChange} step={step} value={[minValueState, maxValueState]} />
    </div>;
};